export enum SelectType {
  Radio = 'radio',
  RadioImgRender = 'radio_img_render',
  RadioImg = 'radioimg',
  Switcher = 'switcher',
  SwitcherSelect = 'switcher-select',
  Multiple = 'multiple',
  Autocomplete = 'autocomplete',
  Chip = 'chip',
  ChipMultiple = 'chip-multiple',
}
